


















import Component, { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import ErrorMixin from "@/mixins/errorMixins";

@Component({
  components: {},
})
export default class Configuration extends mixins(MobileMixin, ErrorMixin) {
  public rules: any = [];

  public mounted() {
    this.$store.dispatch("config/getRules").then((messages: any) => {
      this.rules = messages;
    });
  }

  public getLabel(rule: any) {
    return rule.active
      ? this.$t("Active").toString()
      : this.$t("Inactive").toString();
  }

  public updateRule(rule: any) {
    this.$store.dispatch("config/updateRule", rule).then(
      (messages: any) => {
        console.log(messages);
        this.setSuccess(this.$t("SuccessMod").toString());
      },
      (error: any) => {
        this.setErrorFromTxt(error.toString());
      }
    );
  }
}
